import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { get as getSession } from 'features/session/store/actions'
import { get as getNotifications } from 'features/notifications/store/actions'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getSession,
      getNotifications
    },
    dispatch
  )
})

class Preloader extends Component {
  componentDidMount() {
    this.props.actions.getSession()
    this.props.actions.getNotifications()
  }

  render() {
    return <div id="preloader-page" />
  }
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(Preloader)



// WEBPACK FOOTER //
// ./src/pages/preloader/index.js